import { render, staticRenderFns } from "./warehousingTask.vue?vue&type=template&id=1974730a&scoped=true&"
import script from "./warehousingTask.vue?vue&type=script&lang=js&"
export * from "./warehousingTask.vue?vue&type=script&lang=js&"
import style0 from "./warehousingTask.vue?vue&type=style&index=0&id=1974730a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1974730a",
  null
  
)

export default component.exports